import { useCallback, useState } from 'react';

// Components
import Header from '@components/Header';
import LandscapeNotifier from '@components/LandscapeNotifier';
/*import SwitchButton from '@components/SwitchButton';*/
import Cookies from 'js-cookie'
import {
    FaPlusCircle
} from 'react-icons/fa';

// Assets
// @ts-ignore
//import WhiteshieldLogoWhite from '@assets/whiteshield_logo-white.png';
//import WhiteshieldLogo from '@assets/whiteshield_logo.png';
import BackgroundDark from '@assets/login-background.jpg';
import BackgroundLight from '@assets/background-light.jpg';

import './Compare.scss';
import CompareColumnNew from '@components/CompareColumn';

const Compare = () => {
    const [darkMode] = useState<boolean>(Cookies.get('darkMode') === "true");
    const [compareColumns, setCompareColumns] = useState<any[]>([{}]);

    //const handleSwitchDarkMode = () => {
    //    document.body.classList.remove(darkMode === true ? "darkMode" : "lightMode")
    //    document.body.classList.add(darkMode === false ? "darkMode" : "lightMode")
    //    Cookies.set('darkMode', (!darkMode).toString())
    //    setDarkMode(!darkMode);
    //};

    const handleAddCompareColumn = useCallback(() => {
        setCompareColumns([...compareColumns, compareColumns[compareColumns.length - 1]]);
    }, [compareColumns]);

    const handleChangeCompareColumnOptions = useCallback((compareColumnOptions, index) => {
        const tempCompareColumns = [...compareColumns];
        tempCompareColumns[index] = compareColumnOptions;
        setCompareColumns(tempCompareColumns);
    }, [compareColumns]);

    return (
        <div>
            <LandscapeNotifier />
            <Header />
            <div className="compare">
                <div className="compare__content">
                    {
                        compareColumns.map((compareColumn: any, index: number) => {
                            return <CompareColumnNew key={index} index={index} preSelectedOptions={compareColumn} handleChangePreSelectedOptions={(options) => handleChangeCompareColumnOptions(options, index)} />
                        })
                    }
                    <div className="col-md-1">
                        <div className="compare__addCompareButton">
                            <span onClick={handleAddCompareColumn}>
                                <FaPlusCircle size={50} />
                            </span>
                        </div>
                    </div>
                </div>
                {/*
                <div className="compare-footer">
                    <div>Powered by</div>
                    <img src={Cookies.get('darkMode') === "true" ? WhiteshieldLogoWhite : WhiteshieldLogo} alt="" />
                </div>
                */}
                <div
                    className="compare__background"
                    style={{ backgroundImage: `url(${darkMode ? BackgroundDark : BackgroundLight})` }}
                />
                <div className="compare__mask" />
            </div>
            {/*<div className="compare__switch-buttons">
                <div>
                    <div>Dark mode</div>
                    <SwitchButton
                        labels={['ON', 'OFF']}
                        active={darkMode}
                        onClick={handleSwitchDarkMode}
                        width={100}
                    />
                </div>
            </div>*/}
        </div>
    );
};

export default Compare;
